import { Facebook, Github, Instagram, Linkedin } from "lucide-react";
import styles from "./SocialIconRow.module.css";

function TikTokIcon({ size = 18 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.84-.1z" />
    </svg>
  );
}

type Social = {
  name: string;
  href: string;
  brand: string;
  icon: React.ReactNode;
};

const ICON_SIZE = 18;

export const SOCIAL_LINKS: Social[] = [
  {
    name: "Facebook",
    href: "https://www.facebook.com/borstphoto",
    brand: "#1877F2",
    icon: <Facebook size={ICON_SIZE} />,
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/borstphoto/",
    brand:
      "linear-gradient(45deg, #405de6, #5b51db, #b33ab4, #c135b4, #e1306c, #fd1f1f)",
    icon: <Instagram size={ICON_SIZE} />,
  },
  {
    name: "TikTok",
    href: "https://www.tiktok.com/@borstphoto",
    brand: "#0a0a0a",
    icon: <TikTokIcon size={ICON_SIZE} />,
  },
  {
    name: "LinkedIn",
    href: "https://www.linkedin.com/in/jason-borst-300067a2/",
    brand: "#0274B3",
    icon: <Linkedin size={ICON_SIZE} />,
  },
  {
    name: "GitHub",
    href: "https://github.com/CartKeeper",
    brand: "#24262A",
    icon: <Github size={ICON_SIZE} />,
  },
];

export default function SocialIconRow({ className }: { className?: string }) {
  return (
    <div className={`${styles.row} ${className ?? ""}`}>
      {SOCIAL_LINKS.map((s) => (
        <div
          key={s.name}
          className={styles.item}
          style={{ "--brand-fill": s.brand } as React.CSSProperties}
        >
          <a
            href={s.href}
            aria-label={s.name}
            className={styles.link}
            target="_blank"
            rel="noreferrer"
          >
            <span className={styles.fill} aria-hidden="true" />
            <span className={styles.icon}>{s.icon}</span>
          </a>
          <span className={styles.tooltip}>{s.name}</span>
        </div>
      ))}
    </div>
  );
}
